// extracted by mini-css-extract-plugin
export default {"root":"WordStructureTable_root__37_Sz","rtl":"WordStructureTable_rtl__1CBLs","part":"WordStructureTable_part__3ZW2N","explainer":"WordStructureTable_explainer__1c9An"};